var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "py-6" }, [
    _c("h3", { staticClass: "text-lg font-medium mb-4" }, [
      _vm._v("Step 1 of 9: Required Services"),
    ]),
    _c(
      "div",
      { staticClass: "grid grid-cols-1 gap-6" },
      [
        _c(
          "ValidationProvider",
          { attrs: { name: "Support Type" } },
          [
            _c(
              "FormGroup",
              {
                attrs: { title: "Support Type" },
                scopedSlots: _vm._u([
                  {
                    key: "title",
                    fn: function () {
                      return [
                        _c("p", { staticClass: "mb-2" }, [
                          _vm._v(" Support Type "),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              },
              [
                _c("FormMultiselect", {
                  attrs: {
                    name: "support_type",
                    getParentCustom: "clientWidth",
                    multiple: true,
                    placeholder: "Select support workers",
                    options: _vm.supportTypeOptions,
                    inputClass: "w-full",
                  },
                  on: {
                    input: (val) => {
                      _vm.updateField("support_type", val)
                      _vm.updateFrequence(val)
                    },
                  },
                  model: {
                    value: _vm.formData.support_type,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "support_type", $$v)
                    },
                    expression: "formData.support_type",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm.isFrequencySelect || _vm.formData.frequency
          ? _c(
              "ValidationProvider",
              { attrs: { name: "Frequency" } },
              [
                _c(
                  "FormGroup",
                  {
                    attrs: { title: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "title",
                          fn: function () {
                            return [
                              _c("p", { staticClass: "mb-2" }, [
                                _vm._v(" Frequency "),
                                _c(
                                  "span",
                                  { staticClass: "text-sub-heading" },
                                  [_vm._v("(optional)")]
                                ),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      493176879
                    ),
                  },
                  [
                    _c("FormMultiselect", {
                      attrs: {
                        getParentCustom: "clientWidth",
                        name: "frequency",
                        placeholder: "Select frequency",
                        options: _vm.frequencyOptions,
                        inputClass: "w-full",
                      },
                      on: { input: (val) => _vm.updateField("frequency", val) },
                      model: {
                        value: _vm.formData.frequency,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "frequency", $$v)
                        },
                        expression: "formData.frequency",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }